var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"reponse-menu"},[_c('a',{attrs:{"href":"#GoMainMenu"}},[_vm._v("메인 메뉴 바로가기")]),_c('a',{attrs:{"href":"#GoContent"}},[_vm._v("본문 바로가기")]),_c('a',{attrs:{"href":"#GoGMenu"}},[_vm._v("글로벌 메뉴 바로가기")])])])
}]

export { render, staticRenderFns }